var CustomerOrderStatus;
(function (CustomerOrderStatus) {
    CustomerOrderStatus[CustomerOrderStatus["NotInitialized"] = 0] = "NotInitialized";
    CustomerOrderStatus[CustomerOrderStatus["Registered"] = 1] = "Registered";
    CustomerOrderStatus[CustomerOrderStatus["OrderConfirmationPrinted"] = 2] = "OrderConfirmationPrinted";
    CustomerOrderStatus[CustomerOrderStatus["CanNotConfirmDeliveryTime"] = 3] = "CanNotConfirmDeliveryTime";
    CustomerOrderStatus[CustomerOrderStatus["DeliveryNotePrinted"] = 4] = "DeliveryNotePrinted";
    CustomerOrderStatus[CustomerOrderStatus["PartiallyDelivered"] = 5] = "PartiallyDelivered";
    CustomerOrderStatus[CustomerOrderStatus["History"] = 9] = "History";
})(CustomerOrderStatus || (CustomerOrderStatus = {}));
export default CustomerOrderStatus;
